import { render, staticRenderFns } from "./Phoneinput.vue?vue&type=template&id=fa1a5bd4&scoped=true&"
import script from "./Phoneinput.vue?vue&type=script&lang=ts&"
export * from "./Phoneinput.vue?vue&type=script&lang=ts&"
import style0 from "./Phoneinput.vue?vue&type=style&index=0&id=fa1a5bd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1a5bd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VTextField})
